/**
 * Enum to define error severity levels.
 *
 * @enum {string}
 * @property {string} CRITICAL - Critical severity level
 * @property {string} WARNING - Warning severity level
 * @property {string} INFO - Informational severity level
 */
export var ErrorSeverity;
(function (ErrorSeverity) {
    ErrorSeverity["CRITICAL"] = "critical";
    ErrorSeverity["WARNING"] = "warning";
    ErrorSeverity["INFO"] = "info";
    ErrorSeverity["ERROR"] = "ERROR";
})(ErrorSeverity || (ErrorSeverity = {}));
//# sourceMappingURL=errorSeverity.types.js.map